module.exports = __webpack_public_path__ + "img/deliver-img-3-3.c94fe57f.png";